import React from 'react';
import {useParams, Switch, Route, Redirect} from 'react-router-dom';
import {useFormQuery} from 'api';
import {ExclamationCircleIcon} from '@heroicons/react/24/outline';
import Pages from './pages';

export default () => {
  const {formId} = useParams<{
    formId: string;
  }>();

  const {data: {form} = {}} = useFormQuery({
    variables: {
      uuid: formId,
    },
  });

  if (!form) return null;

  if (form.status !== 'open') {
    return (
      <div className="flex items-center justify-center py-12 px-4 w-screen h-screen">
        <div className="flex flex-col items-center gap-8">
          <ExclamationCircleIcon className="w-20 h-20 text-red-500" />
          <h1 className="text-lg font-bold text-center leading-normal">
            このフォームは以下のいずれかの理由により、表示ができません。
          </h1>
          <ul className="list-disc">
            <li>フォームが公開前である</li>
            <li>削除、または非公開の設定になっている</li>
            <li>URLが間違っている</li>
          </ul>
        </div>
      </div>
    );
  }

  return (
    <Switch>
      <Route path="/forms/:formId/pages">
        <Pages form={form} />
      </Route>
      <Redirect to={`/forms/${formId}/pages`} />
    </Switch>
  );
};
